import { Box, IconTextLink, SecondaryButton, Typography } from "@husqvarna/ui-core";
import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import PageContainer from "../../shared/components/PageContainer/PageContainer";
import Service from "../components/Services/Service";
import ProjectMap from "../components/ProjectMap";

const Services = () => {
  const intl = useIntl();
  // TODO: Implement for real
  const [noServices, setNoServices] = useState(true);
  const [services, setServices] = useState<string[]>([]);
  const onAddService = () => {
    setServices((old) => [...old, `service-${old.length}`]);
  };
  // ---------------
  return (
    <>
      <PageContainer headline={intl.formatMessage({id: "projects.services.heading", defaultMessage: "Services"})} description="">
        <Box justifyContent="space-between" mr={12}>
          <IconTextLink 
            iconId="plus" 
            variant="Body2" 
            onClick={onAddService}
            text={intl.formatMessage({
              id: "projects.services.addService",
              defaultMessage: "Add service"
            })} />
        </Box>
        {!services?.length && (
          <Box 
            flexGrow={1} 
            justifyContent="center" 
            textAlign="center" 
            alignItems="center" 
            flexDirection="column"
          >
            <Typography variant="Heading4" tag="h2">
              <FormattedMessage
                id="projects.services.noServiceHeading"
                defaultMessage="Add service"
              />
            </Typography>
            <Typography variant="Body1" tag="p" mt={3}>
              <FormattedMessage
                id="projects.services.noServiceText"
                defaultMessage="You don't have any services yet, add one to get started!"
              />
            </Typography>
            <SecondaryButton mt={7} onClick={onAddService} text={intl.formatMessage({
              id: "projects.services.addService",
              defaultMessage: "Add service"
            })} />
          </Box>
        )}
        {!!services.length && services.map((service) => (
          <Service key={service} />
        ))}
      </PageContainer>
      <ProjectMap />
    </>
  );
}

export default Services;